/* Crosses out the full price next to the buy-box total whenever a volume tier applies.
   zappy.js writes the total as plain text; this rewrites it after each update. */
(function () {
  'use strict';
  var money = function (n) { return '$' + n.toFixed(2); };
  document.querySelectorAll('[data-buybox]').forEach(function (root) {
    var tiers;
    try { tiers = JSON.parse(root.dataset.tiers); } catch (e) { return; }
    var base = tiers[tiers.length - 1][1];
    var unitFor = function (q) {
      for (var i = 0; i < tiers.length; i++) if (q >= tiers[i][0]) return tiers[i][1];
      return base;
    };
    var el = root.querySelector('[data-price-total]');
    if (!el) return;
    var apply = function () {
      var q = parseInt(root.dataset.qty || root.dataset.defaultQty, 10) || 1;
      var total = q * unitFor(q), full = q * base;
      var html = full > total ? '<s class="priceline__was">' + money(full) + '</s>' + money(total) : money(total);
      if (el.innerHTML !== html) el.innerHTML = html;
    };
    new MutationObserver(apply).observe(el, { childList: true, characterData: true, subtree: true });
    new MutationObserver(apply).observe(root, { attributes: true, attributeFilter: ['data-qty'] });
    apply();
  });
})();
